import { FigureVarData, isFigureVarData } from "./FigureVarData";

export interface FigureAxisData {
  id: string;
  axisType: string;
  properties: FigureVarData[];
}

/**
 * Type guard to check if an object is a FigureAxisData
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureAxisData
 */
export const isFigureAxisData = (obj: unknown): obj is FigureAxisData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureAxisData;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.axisType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((prop) => !isFigureVarData(prop))) {
    return false;
  }
  return true;
};
